var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgKickerCircles = function SvgKickerCircles(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 17,
    y: 1,
    width: 7,
    height: 7,
    rx: 3.5,
    fill: "#3D50FC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 9,
    y: 3,
    width: 13,
    height: 13,
    rx: 6.5,
    fill: "#D80C9A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 2,
    y: 7,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#05A1C9"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgKickerCircles);
var Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyAgdmlld0JveD0iMCAwIDI1IDI1IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCBvcGFjaXR5PSIwLjYiIHg9IjE3IiB5PSIxIiB3aWR0aD0iNyIgaGVpZ2h0PSI3IiByeD0iMy41IiBmaWxsPSIjM0Q1MEZDIi8+CjxyZWN0IG9wYWNpdHk9IjAuNiIgeD0iOSIgeT0iMyIgd2lkdGg9IjEzIiBoZWlnaHQ9IjEzIiByeD0iNi41IiBmaWxsPSIjRDgwQzlBIi8+CjxyZWN0IG9wYWNpdHk9IjAuNiIgeD0iMiIgeT0iNyIgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiByeD0iOCIgZmlsbD0iIzA1QTFDOSIvPgo8L3N2Zz4K";